// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import { mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../common/enums/RequestFilterEnums';

export const convertTableFiltersToRequestFilter = (tableFilters, columns) => {

    let convertedFilters = [];

    tableFilters.items.map((item) => {

        if (!item && !item.value) return;

        var findColumn = columns.find(x => x.field == item.field);

        convertedFilters.push({
            field: item.field,
            values: [item?.value?.toString()],
            valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
            operationType: mapReactMUIToFilterOperationTypes(item.operator)
        });
    });

    return convertedFilters;
}